"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24ToteLine = function Svg24ToteLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M10 9a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2h-4z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.589 9.254c.056-.281.121-.605.153-.89.035-.32.058-.81-.127-1.345a3 3 0 0 0-1.317-1.607 3.034 3.034 0 0 0-1.294-.387A10.834 10.834 0 0 0 18.102 5H5.898c-.286 0-.616 0-.902.025a3.033 3.033 0 0 0-1.294.387A3 3 0 0 0 2.385 7.02a3.033 3.033 0 0 0-.127 1.345c.032.285.097.609.153.89l1.378 6.89c.039.195.087.433.145.643.07.248.186.587.426.93a3 3 0 0 0 1.258 1.032c.384.167.739.216.996.235.217.016.46.016.658.016h9.456c.198 0 .44 0 .658-.016.257-.02.612-.068.996-.235a3 3 0 0 0 1.258-1.032c.24-.343.357-.681.426-.93.058-.21.106-.448.145-.642l1.378-6.891zM18.049 7c.668 0 1.003 0 1.237.137a1 1 0 0 1 .44.536c.088.257.022.585-.109 1.24l-1.36 6.8c-.091.459-.137.688-.257.86a1 1 0 0 1-.42.343c-.19.084-.424.084-.892.084H7.312c-.468 0-.701 0-.893-.084a1 1 0 0 1-.42-.344c-.119-.171-.165-.4-.256-.858l-1.36-6.8c-.131-.656-.197-.984-.108-1.24a1 1 0 0 1 .439-.537C4.948 7 5.283 7 5.952 7h12.096z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24ToteLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24ToteLine;
exports.default = _default;